import React from 'react'
import { Link } from 'react-router-dom'
import { Card } from '@/components/ui/card'
import { LucideIcon } from 'lucide-react'

interface DashboardStatCardProps {
  value: number
  label: string
  subtitle?: string
  icon: LucideIcon
  colorClass?: string
  href?: string
}

const DashboardStatCard: React.FC<DashboardStatCardProps> = ({
  value,
  label,
  subtitle,
  icon: Icon,
  colorClass = 'text-foreground',
  href,
}) => {
  const content = (
    <Card className={`p-4 ${href ? 'hover:bg-muted/50 transition-colors cursor-pointer' : ''}`}>
      <div className="flex items-center justify-between">
        <div>
          <span className={`text-3xl font-bold leading-none ${colorClass}`}>{value}</span>
          <h4 className="text-sm font-medium text-foreground mt-1">{label}</h4>
          {subtitle && <p className="text-xs text-muted-foreground mt-0.5">{subtitle}</p>}
        </div>
        <Icon className="h-8 w-8 text-muted-foreground/20" />
      </div>
    </Card>
  )

  if (href) {
    return <Link to={href}>{content}</Link>
  }

  return content
}

export default DashboardStatCard
